import React, { useState, useEffect } from "react";
import plus from "../../../src/assets/Images/plus.svg";
import { Breadcrumb, Button, ConfigProvider, Select } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import Navbar from "../../components/Navbar/Navbar";
import { routes } from "../../Routes";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import i18next from "i18next";
import {
  getBillPaymentHistory,
  getPaymentsList,
  getVendors,
} from "../../API  Functions/PurchaseFunctions";
import moment from "moment";
import PurchasePayment from "../../modals/purchasePaymentModal";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import LoadingSpinner from "../../components/Loading";
import { Drawer } from "antd";
import { DatePicker } from "antd";
import SelectBox from "../../components/CustomWidgets/EOrderFilter";
import VendorPaymentTable from "./VendorPaymentTable";
import ShimmerLoader from "../../loading";
import DateFilter from "../../components/ui/DateFilter";
import dayjs from "dayjs";
import { checkPermission } from "../../Utils/permissionHelper";
import { toast } from "react-toastify";

const { RangePicker } = DatePicker;

const disabledDate = (current) => {
  // Disable dates that are after today
  return current && current > moment().endOf("day");
};

const SupplyPayment = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector((state) => state?.login?.user?.result?.company_id);
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );
  const { Option } = Select;
  const [popup, setpopup] = useState(false);
  const [selectedBillId, setSelectedBillId] = useState(null);
  const [selectedDueAmount, setSelectedDueAmount] = useState(null);
  const [visible, setVisible] = useState(false);
  const [paymentHistoryData, setPaymentHistoryData] = useState([]);
  const [drawerData, setDrawerData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedPaymentType, setSelectedPaymentType] = useState(
    t("all_orders")
  );
  const today = dayjs();

  const formatToday = today.format("YYYY-MM-DD");
  const startofMonth = today.startOf("month").format("YYYY-MM-DD");
  const [dateRange, setDateRange] = useState([null, null]);
  const [noOrdersFound, setNoOrdersFound] = useState(false);
  const [fetchedOrdersCount, setFetchedOrdersCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [selectedVendorID, setSelectedVendorID] = useState("");
  const [data, setData] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [selectedRange, setSelectedRange] = useState("thisMonth");
  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);

  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset

  const showDrawer = (historyData) => {
    setDrawerData(historyData);
    setVisible(true);
    getPaymentHistory(historyData.bill_id);
    setSelectedUserId(historyData.bill_id);
  };

  useEffect(() => {
    getVendorsData();
  }, [popup]);

  useEffect(() => {
    getSessionList(
      "",
      selectedPaymentType,
      startDate,
      endDate,
      currentOffset,
      currentLimit,
      selectedVendorID
    );
  }, [currentLimit, currentOffset]);

  const getPaymentHistory = (billId) => {
    const payload = {
      bill_id: billId,
    };
    getBillPaymentHistory(payload)
      .then((res) => {
        if (res?.result?.payments.length > 0) {
          setPaymentHistoryData(res?.result?.payments);
          setLoading(false);
        } else {
          console.error("No session history found");
        }
      })
      .catch((error) => {
        console.error("Error fetching session history:", error);
      });
  };

  const getVendorsData = () => {
    getVendors(user_id).then((res) => {
      setVendors(res);
    });
  };

  const onClose = () => {
    setVisible(false);
  };

  const getSessionList = (
    search = "",
    paymentType = "all",
    startDate = null,
    endDate = null,
    offset = 0,
    limit,
    vendorID
  ) => {
    let paymentStatus = "";
    if (paymentType === 1) {
      paymentStatus = "paid";
    } else if (paymentType === 2) {
      paymentStatus = "not_paid";
    } else if (paymentType === 3) {
      paymentStatus = "partial";
    }
    // setLoading(true);
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      user_id: user_id,
      payment_status: paymentStatus,
      vendor_name: search,
      start_date: startDate,
      end_date: endDate,
      limit: limit,
      offset: offset,
      ...(vendorID && { vendor_id: vendorID }),
    };

    getPaymentsList(payload)
      .then((res) => {
        if (res?.result?.status === "No Orders") {
          setNoOrdersFound(true);
          setData([]);
          setFetchedOrdersCount(0);
          setLoading(false);
        } else if (res?.result?.vendor_bills.length > 0) {
          const AllList = res.result?.vendor_bills;
          setData(AllList);
          setFetchedOrdersCount(AllList.length);
          setNoOrdersFound(false);
          setLoading(false);
        } else {
          console.error("Response was not successful:", res);
          setNoOrdersFound(true);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching store users:", error);
        setNoOrdersFound(true);
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   getSessionList();
  // }, []);

  // const handlePaymentClick = (val) => {
  //   setSelectedBillId(val?.bill_id);
  //   setSelectedDueAmount(val?.due_amount);
  //   setIsModalVisible(true);
  // };

  const handlePaymentClick = (val) => {
    if (!checkPermission("/purchase/supplyPayment", isGinne)) {
      // toast.error("You do not have permission to perform this action.");
      return;
    }
    setSelectedBillId(val?.bill_id);
    setSelectedDueAmount(val?.due_amount);
    setIsModalVisible(true);
  };

  const handleSearchChange = (value) => {
    setLoading(true);
    setSearchKeyword(value);
    setCurrentPage(1); // Reset to the first page when searching
    getSessionList(value, selectedPaymentType, startDate, endDate, 0, 10, null);
  };

  const handlePaymentTypeChange = (event) => {
    const paymentType = event.target.value;
    setLoading(true);
    setSearchKeyword("");
    setSelectedPaymentType(paymentType);
    setCurrentPage(1); // Reset to the first page when changing payment type
    getSessionList(searchKeyword, paymentType, startDate, endDate, 0, 10, selectedVendorID);
  };

  const options = [
    {
      value: 0,
      label: `${t("all_orders")}`,
    },
    {
      value: 1,
      label: `${t("Paid")}`,
    },
    {
      value: 2,
      label: `${t("Unpaid")} `,
    },
    {
      value: 3,
      label: `${t("Partial Payment")} `,
    },
  ];

  const handleSelectVendor = (val) => {
    if (val == "All Vendors") {
      setSelectedVendorID(null);
      setSelectedVendor("");
      getSessionList(
        searchKeyword,
        selectedPaymentType,
        startDate,
        endDate,
        0,
        10,
        null
      );
      return;
    }
    console.log("Selected Vendor==>", val);
    setLoading(true);
    setSelectedVendorID(val);
    getSessionList(
      searchKeyword,
      selectedPaymentType,
      startDate,
      endDate,
      0,
      10,
      val
    );
    const vendorName = vendors?.find((item) => item.id == val)?.name;
    setSelectedVendor(vendorName);
  };

 return (
  <>
    {/* {loading && <LoadingSpinner />} */}

    <div className="">
      <div className="flex flex-col bg-[#F6F7F9] min-h-[93vh] flex-1">
        <Navbar heading="Vendor Invoices" />

        <div className="px-4 md:px-5 font-extrabold">
          {/* Search + Filters Section */}
          <div className="flex flex-col xl:flex-row justify-between xl:items-end gap-4 mt-2 md:me-8">

            {/* Search */}
            <div className="w-full xl:w-auto">
              <SearchBox
                placeholder={t("Search Vendor/Order No")}
                searchResult={handleSearchChange}
              />
            </div>

            {/* Filters */}
            <div className="flex flex-col md:flex-row gap-3 sm:gap-4 items-stretch sm:items-end justify-end w-full xl:w-auto">

              {/* Vendor Select */}
              <Select
                className="overflow-hidden w-full sm:w-auto"
                style={{
                  width: window.innerWidth < 640 ? "100%" : 200,
                  minWidth: window.innerWidth < 640 ? "100%" : 200,
                  height: 40,
                }}
                placeholder={t("Select Vendors")}
                value={selectedVendor || "All Vendors"}
                onChange={handleSelectVendor}
              >
                <Option value="All Vendors">
                  {t("All Vendors")}
                </Option>

                {vendors?.map((option) => {
                  const { id, name, phone, email } = option;
                  let displayText = name;

                  if (phone) {
                    displayText += ` (${phone})`;
                  } else if (email) {
                    displayText += ` (${email})`;
                  }

                  return (
                    <Option key={id} value={id}>
                      {displayText}
                    </Option>
                  );
                })}
              </Select>

              {/* Payment Type Filter */}
              <SelectBox
                style={{
                  width: window.innerWidth < 640 ? "100%" : 140,
                }}
                width={140}
                placeholder={"all_orders"}
                name="filter"
                onChange={handlePaymentTypeChange}
                options={options}
                value={selectedPaymentType}
              />

              {/* Date Filter */}
              <DateFilter
                setSelectedRange={setSelectedRange}
                selectedRange={selectedRange}
                SubmitFilter={(start, date) => {
                  setSearchKeyword("");
                  setCurrentLimit(10);
                  setCurrentOffset(0);
                  setStartDate(start);
                  setEndDate(date);

                  getSessionList(
                    searchKeyword,
                    selectedPaymentType,
                    start,
                    date,
                    0,
                    10,
                    null
                  );
                }}
              />
            </div>
          </div>

          {/* Table Section */}
          <>
            <div className="flex justify-between items-center"></div>

            {loading ? (
              <ShimmerLoader />
            ) : (
              <div className="overflow-x-auto w-full mt-4">
                <VendorPaymentTable
                  handlePaymentClick={handlePaymentClick}
                  showDrawer={showDrawer}
                  additionalData={data}
                  pagination={(values) => {
                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                  }}
                />
              </div>
            )}
          </>
        </div>
      </div>
    </div>

    {/* Payment Modal */}
    {isModalVisible && (
      <PurchasePayment
        isOpen={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        bill_id={selectedBillId}
        page={"supplyPayment"}
        due_amount={selectedDueAmount}
        Popup={() => {
          setpopup(true);
        }}
        onPaymentSuccess={()=>{
          getSessionList(
      "",
      selectedPaymentType,
      startDate,
      endDate,
      currentOffset,
      currentLimit,
      selectedVendorID
    );
        }}
        store_id={store_id}
      />
    )}

    {/* Payment History Drawer */}
    <Drawer
      title={t("Payment History")}
      placement="right"
      width={window.innerWidth < 768 ? "100%" : 500}
      onClose={onClose}
      visible={visible}
    >
      {loading ? (
        <div>{t("Loading session data...")}</div>
      ) : (
        <div>
          {paymentHistoryData.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full min-w-[550px]">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2 text-start">
                      {t("Payment Date & Time")}
                    </th>
                    <th className="p-2 text-start">
                      {t("Type")}
                    </th>
                    <th className="p-2 text-start">
                      {t("amount")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {paymentHistoryData.map((payment, index) => (
                    <tr
                      key={index}
                      className="border-b"
                    >
                      <td className="p-2">
                        {moment(payment.payment_date).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                      </td>

                      <td className="p-2">
                        {t(payment.type)}
                      </td>

                      <td className="p-2">
                        {"EGP"} {payment.amount}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>{t("No payment history available")}</p>
          )}
        </div>
      )}
    </Drawer>
  </>
);
};

export default SupplyPayment;
